import { calcSceneDiagonal } from '@shared/utils';

const calcPointLightDistance = (sceneBox) => Math.ceil(calcSceneDiagonal(sceneBox) * 1.5);

export default calcPointLightDistance;
